// // src/components/search/SearchModal.tsx

// 'use client';
// import { useEffect, useMemo, useRef, useState } from 'react';
// import styles from './SearchModal.module.scss';
// import { useDebounce } from '@/hooks/useDebounce';
// import type { SearchUserStoreItem } from '@/types/search';
// import { SearchService } from '@/libs/services/search';
// import { IconSearch } from '@/components/icons';
// import axios from 'axios';
// import Link from 'next/link';
// import { Avatar } from 'antd';

// export default function SearchModal() {
//   const [open, setOpen] = useState(false);
//   const [q, setQ] = useState('');
//   const debouncedQ = useDebounce(q, 220);
//   const [results, setResults] = useState<SearchUserStoreItem[]>([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);
//   const [activeIndex, setActiveIndex] = useState(0);
//   const inputRef = useRef<HTMLInputElement | null>(null);
//   const listRef = useRef<HTMLUListElement | null>(null);
//   const abortRef = useRef<AbortController | null>(null);

//   const openModal = () => setOpen(true);
//   const closeModal = () => {
//     abortRef.current?.abort(); // ✅ 關閉時中止請求
//     setOpen(false);
//     setQ('');
//     setResults([]);
//     setActiveIndex(0);
//     setLoading(false);
//     setError(null);
//   };

//   useEffect(() => {
//     if (!open) return;
//     const prev = document.body.style.overflow;
//     document.body.style.overflow = 'hidden';
//     return () => {
//       document.body.style.overflow = prev;
//     };
//   }, [open]);

//   useEffect(() => {
//     if (open) {
//       const t = setTimeout(() => inputRef.current?.focus(), 60);
//       return () => clearTimeout(t);
//     }
//   }, [open]);

//   // 使用封裝：監聽 debounced 關鍵字 → 呼叫 API（支援取消）
//   useEffect(() => {
//     if (!open) return;
//     if (abortRef.current) abortRef.current.abort();
//     const controller = new AbortController();
//     abortRef.current = controller;

//     async function fetchData() {
//       try {
//         setLoading(true);
//         setError(null);
//         const items = await SearchService.getUserStoreItem(debouncedQ, 1, controller.signal);
//         console.log('[search] kw=', debouncedQ, 'items=', items);
//         setResults(items || []);
//         setActiveIndex(0);
//       } catch (err: unknown) {
//         let apiMsg = '發生錯誤';
//         if (axios.isAxiosError(err)) {
//           apiMsg = err.response?.data?.message ?? apiMsg;
//         } else if (err instanceof Error) {
//           apiMsg = err.message || apiMsg;
//         }
//         setError(apiMsg);
//       } finally {
//         setLoading(false);
//       }
//     }

//     fetchData();
//     return () => controller.abort();
//   }, [debouncedQ, open]);

//   useEffect(() => {
//     if (!open) return;
//     function onKeyDown(e: KeyboardEvent) {
//       if (e.key === 'Escape') {
//         e.preventDefault();
//         closeModal();
//       } else if (e.key === 'ArrowDown') {
//         e.preventDefault();
//         setActiveIndex((i) => Math.min(i + 1, Math.max(0, results.length - 1)));
//         scrollActiveIntoView();
//       } else if (e.key === 'ArrowUp') {
//         e.preventDefault();
//         setActiveIndex((i) => Math.max(i - 1, 0));
//         scrollActiveIntoView();
//       } else if (e.key === 'Enter') {
//         e.preventDefault();
//         if (results[activeIndex]) selectItem(results[activeIndex]);
//       }
//     }
//     window.addEventListener('keydown', onKeyDown);
//     return () => window.removeEventListener('keydown', onKeyDown);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [open, results, activeIndex]);

//   function scrollActiveIntoView() {
//     const ul = listRef.current;
//     if (!ul) return;
//     const li = ul.querySelector<HTMLLIElement>('li[aria-selected="true"]');
//     if (li) li.scrollIntoView({ block: 'nearest' });
//   }

//   function selectItem(item: SearchUserStoreItem) {
//     // router.push(`/search?kw=${encodeURIComponent(item.name)}`);
//     alert(`你選擇了：「${item.owner_open_id}」`);
//     closeModal();
//   }

//   const hasQuery = useMemo(() => debouncedQ.trim().length > 0, [debouncedQ]);

//   function highlight(text: string, kw: string) {
//     if (!kw) return text;
//     const parts = text.split(new RegExp(`(${escapeRegExp(kw)})`, 'ig'));
//     return parts.map((p, i) =>
//       p.toLowerCase() === kw.toLowerCase() ? (
//         <mark key={i} className={styles.mark}>
//           {p}
//         </mark>
//       ) : (
//         <span key={i}>{p}</span>
//       )
//     );
//   }

//   function escapeRegExp(s: string) {
//     if (typeof s !== 'string') return '';
//     return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
//   }

//   return (
//     <div className={styles.root}>
//       <button type="button" aria-label="搜尋" className={styles.trigger} onClick={openModal}>
//         <IconSearch width={24} />
//       </button>
//       {open && (
//         <div className={styles.modalRoot} role="dialog" aria-modal="true" aria-label="搜尋視窗">
//           <div className={styles.backdrop} onClick={closeModal} />
//           <div className={styles.panel} role="document">
//             <div className={styles.header}>
//               <input
//                 ref={inputRef}
//                 value={q}
//                 onChange={(e) => {
//                   setQ(e.target.value);
//                   setActiveIndex(0);
//                 }}
//                 placeholder="我要找..."
//                 aria-label="我要找..."
//                 className={styles.input}
//               />
//               <button
//                 type="button"
//                 className={styles.closeBtn}
//                 aria-label="關閉搜尋"
//                 onClick={closeModal}
//               >
//                 ✕
//               </button>
//             </div>
//             <ul className={styles.results} ref={listRef} role="listbox">
//               {loading &&
//                 Array.from({ length: 5 }).map((_, idx) => (
//                   <li key={`skeleton-${idx}`} className={styles.skeletonRow} aria-hidden>
//                     <div className={styles.skeletonName}></div>
//                     <div className={styles.skeletonContent}></div>
//                   </li>
//                 ))}

//               {!loading && error && <li className={styles.error}>發生錯誤：{error}</li>}

//               {!loading && !error && results.length === 0 && (
//                 <li className={styles.empty}>
//                   {hasQuery ? <>找不到符合「{debouncedQ}」的結果</> : <>請輸入關鍵字開始搜尋</>}
//                 </li>
//               )}

//               {!loading &&
//                 !error &&
//                 results.map((item, idx) => {
//                   const selected = idx === activeIndex;
//                   const imgSrc =
//                     item.owner_u_s_photo ||
//                     item.owner_small_photo ||
//                     item.owner_u_m_photo ||
//                     item.owner_medium_photo ||
//                     item.owner_u_photo ||
//                     item.owner_photo ||
//                     '';
//                   return (
//                     <li
//                       key={`${item.type}-${item.owner_id}`}
//                       role="option"
//                       aria-selected={selected}
//                       className={`${styles.row} ${selected ? styles.rowActive : ''}`}
//                       onMouseEnter={() => setActiveIndex(idx)}
//                       //onClick={() => selectItem(item)}
//                     >
//                       <Link
//                         href={
//                           item.type === 'store'
//                             ? `/store/${item.owner_open_id}`
//                             : `/user/${item.owner_open_id}`
//                         }
//                         className="d-flex align-items-center py-2"
//                         onClickCapture={closeModal}
//                       >
//                         <div>
//                           {imgSrc ? (
//                             <Avatar src={imgSrc} size={50} />
//                           ) : (
//                             <div
//                               className="rounded-circle bg-grey-100"
//                               style={{ width: 50, height: 50 }}
//                             />
//                           )}
//                         </div>
//                         <div className="ms-3">
//                           <div className={styles.name}>
//                             {' '}
//                             {highlight(String(item.owner_name), debouncedQ)}
//                           </div>
//                           {item.owner_id && (
//                             <div className={styles.content}>
//                               {highlight(String(item.owner_open_id), debouncedQ)}
//                             </div>
//                           )}
//                         </div>
//                       </Link>
//                     </li>
//                   );
//                 })}
//             </ul>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// src/components/search/SearchModal.tsx
'use client';

import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styles from './SearchModal.module.scss';
import { useDebounce } from '@/hooks/useDebounce';
import type { SearchUserStoreItem } from '@/types/search';
import { SearchService } from '@/libs/services/search';
import { IconSearch } from '@/components/icons';
import Link from 'next/link';
import { Avatar } from 'antd';

import InfiniteListWithFetch from '@/components/ui/list/InfiniteListWithFetch';
import type { FetchParams, FetchResult } from '@/hooks/useInfiniteList';

const PAGE_SIZE = 20;

export default function SearchModal() {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const debouncedQ = useDebounce(q, 220);

  const inputRef = useRef<HTMLInputElement | null>(null);

  const openModal = () => setOpen(true);

  const closeModal = () => {
    setOpen(false);
    setQ('');
  };

  // 鎖背景滾動
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  // focus
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => inputRef.current?.focus(), 60);
    return () => clearTimeout(t);
  }, [open]);

  // ESC 關閉
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open]);

  const hasQuery = useMemo(() => debouncedQ.trim().length > 0, [debouncedQ]);

  const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const highlight = (text: string, kw: string) => {
    if (!kw) return text;
    const parts = text.split(new RegExp(`(${escapeRegExp(kw)})`, 'ig'));
    return parts.map((p, i) =>
      p.toLowerCase() === kw.toLowerCase() ? (
        <mark key={i} className={styles.mark}>
          {p}
        </mark>
      ) : (
        <span key={i}>{p}</span>
      )
    );
  };

  const pickImg = (item: SearchUserStoreItem) =>
    item.owner_u_s_photo ||
    item.owner_small_photo ||
    item.owner_u_m_photo ||
    item.owner_medium_photo ||
    item.owner_u_photo ||
    item.owner_photo ||
    '';

  // ✅ 交給 InfiniteListWithFetch：它會自動算 page、觸底載入、顯示 loading
  const fetchData = useCallback(
    async (params: FetchParams): Promise<FetchResult<SearchUserStoreItem>> => {
      const kw = debouncedQ.trim();
      if (!kw) return { items: [], hasMore: false };

      // 兼容不同 useInfiniteList 的 params 形狀：page 或 start
      const pAny = params as any;
      const pageSize = pAny.pageSize ?? PAGE_SIZE;

      const page =
        typeof pAny.page === 'number'
          ? pAny.page
          : typeof pAny.start === 'number'
            ? Math.floor(pAny.start / pageSize) + 1
            : 1;

      const signal: AbortSignal | undefined = pAny.signal;

      const items = await SearchService.getUserStoreItem(kw, page, signal);

      return {
        items: items ?? [],
        hasMore: (items?.length ?? 0) >= pageSize, // 後端固定 20 筆/頁就會準
      };
    },
    [debouncedQ]
  );

  const renderSkeletonRow = useCallback(
    (i: number) => (
      <div key={`sk-${i}`} className={styles.skeletonRow} aria-hidden>
        <div className={styles.skeletonName} />
        <div className={styles.skeletonContent} />
      </div>
    ),
    []
  );

  return (
    <div className={styles.root}>
      <button type="button" aria-label="搜尋" className={styles.trigger} onClick={openModal}>
        <IconSearch width={24} />
      </button>

      {open && (
        <div className={styles.modalRoot} role="dialog" aria-modal="true" aria-label="搜尋視窗">
          <div className={styles.backdrop} onClick={closeModal} />
          <div className={styles.panel} role="document">
            <div className={styles.header}>
              <input
                ref={inputRef}
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="搜尋使用者/店家..."
                aria-label="搜尋使用者/店家"
                className={styles.input}
              />
              <button
                type="button"
                className={styles.closeBtn}
                aria-label="關閉搜尋"
                onClick={closeModal}
              >
                ✕
              </button>
            </div>

            {/* ✅ 注意：InfiniteListWithFetch 會渲染 div/sentinel，所以這裡用 div，不用 ul */}
            <div className={styles.results} role="listbox">
              {!hasQuery ? (
                <div className={styles.empty}>請輸入關鍵字開始搜尋</div>
              ) : (
                <InfiniteListWithFetch<SearchUserStoreItem>
                  className=""
                  pageSize={PAGE_SIZE}
                  rootMargin="160px"
                  resetKey={debouncedQ}
                  resetKind="keyword"
                  bootingSkeletonModeMap={{ keyword: 'initial' }} // ✅ 關鍵字變更時也顯示 skeleton
                  renderSkeleton={renderSkeletonRow}
                  skeletonInitialCount={5}
                  skeletonBaseCount={3}
                  skeletonMinItemsToShow={1}
                  endMinItemsToShow={4}
                  fetchData={fetchData}
                  getKey={(item) => `${item.type}-${item.owner_id}`}
                  emptyView={<div className={styles.empty}>找不到符合「{debouncedQ}」的結果</div>}
                  errorView={<div className={styles.error}>載入失敗，請稍後再試</div>}
                  renderItem={(item) => {
                    const imgSrc = pickImg(item);
                    const href =
                      item.type === 'store'
                        ? `/store/${item.owner_open_id}`
                        : `/user/${item.owner_open_id}`;

                    return (
                      <div
                        role="option"
                        aria-selected={false}
                        className={styles.row}
                        key={`${item.type}-${item.owner_id}`}
                      >
                        <Link
                          href={href}
                          className="d-flex align-items-center"
                          onClickCapture={closeModal}
                        >
                          <div>
                            {imgSrc ? (
                              <Avatar src={imgSrc} size={50} />
                            ) : (
                              <div
                                className="rounded-circle bg-grey-100"
                                style={{ width: 50, height: 50 }}
                              />
                            )}
                          </div>

                          <div className="ms-3">
                            <div className={styles.name}>
                              {highlight(String(item.owner_name), debouncedQ)}
                            </div>
                            <div className={styles.content}>
                              {highlight(String(item.owner_open_id), debouncedQ)}
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  }}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
